import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import CustomTable from '../../../components/customTable';
import getEnvironement from '../../../../environnement';
import CustomBackdrop from '../../../../components/backdrop';
import DeleteDialog from './components/deleteDialog';
import SearchIcon from '@mui/icons-material/Search';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import StatutDialog from './components/statutDialog';

export default function Inscription() {
  const [inscriptions, setInscriptions] = useState([]);
  const [filtredInscriptions, setFiltredInscriptions] = useState(inscriptions);
  const [selectedInscription, setSelectedInscription] = useState();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openStatutDialog, setOpenStatutDialog] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  function getStatut(statut) {
    if (statut === 'Non payé') {
      return (<span className='bg-primary text-white px-5 mx-5 rounded-full inline-block whitespace-nowrap'>Non payé</span>);
    } else {
      return 'Payé';
    }
  }

  const getInscriptions = useCallback(async () => {
    setIsLoader(true);
    const url = `${getEnvironement().API_URL}/getAllInscriptions`;
    await axios.post(url)
      .then((res) => setInscriptions(res.data.inscriptions))
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }, []);

  useEffect(() => {
    setFiltredInscriptions(inscriptions);
  }, [inscriptions]);

  useEffect(() => {
    getInscriptions();
  }, [getInscriptions]);

  return (
    <div className='flex flex-col h-full'>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <StatutDialog
        open={openStatutDialog}
        handleClose={() => setOpenStatutDialog(false)}
        reloadData={getInscriptions}
        inscription={selectedInscription}
      />
      <DeleteDialog
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        reloadData={getInscriptions}
        inscription={selectedInscription}
      />
      <div className='border-2 border-primary rounded-[20px] flex mb-5 items-center col-start-1 col-end-3 xl:col-end-4'>
        <SearchIcon sx={{color: '#A31732', marginLeft: '20px'}} fontSize='large'/>
        <input
          placeholder='Chercher par nom du représentant'
          className='w-full font-inter font-medium text-2xl my-2 mx-5 focus:outline-none'
          onChange={(e) => {
            setFiltredInscriptions(inscriptions.filter(inscription => inscription.nom1.includes(e.target.value)));
          }}
        />
      </div>
      <div className='flex-grow h-[48vh]'>
        <CustomTable
          headers={[
            `ID (${filtredInscriptions.length})`,
            'Nom du représentant',
            'Nom 2',
            'Nom 3',
            'Nom 4',
            'Coach',
            'Pays',
            'Ville',
            'Continent',
            'Catégorie',
            'type de participation',
            'Tel',
            'E-mail',
            'Statut',
            'Actions'
          ]}
          config
        >
          <tbody>
            {
              filtredInscriptions.map((item, index) => {
                return (
                  <tr key={index} className='border-b-2 border-gray'>
                    <td className='text-center font-medium text-xl py-2'>{item.id}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.nom1}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.nom2}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.nom3}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.nom4}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.coach}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.pays}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.ville}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.nationalite}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.profession}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.typeParticipation}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.tel}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.email}</td>
                    <td className='text-center font-medium text-xl py-2'>{getStatut(item.isPayement === 1 ? 'Payé' : 'Non payé')}</td>
                    <td className='text-center font-medium text-xl py-2'>
                      <div className='flex justify-center items-center'>
                        {/* <Tooltip title="Modifier le matériel">
                          <IconButton onClick={() => {
                            setSelectedSoumission(item);
                            // setOpenSoumissionDialog(true);
                          }}
                          >
                            <EditIcon sx={{color: 'black'}}/>
                          </IconButton>
                        </Tooltip> */}
                        <Tooltip title='Modifier le statut'>
                          <IconButton onClick={() => {
                            setSelectedInscription(item);
                            setOpenStatutDialog(true);
                          }}
                          >
                            <ModeEditIcon sx={{color: 'black'}}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Supprimer l'inscription">
                          <IconButton onClick={() => {
                            setSelectedInscription(item);
                            setOpenDeleteDialog(true);
                          }}
                          >
                            <DeleteIcon sx={{color: 'black'}}/>
                          </IconButton>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })
            }
            {filtredInscriptions.length === 0 && (
              <div className='border-dashed border-4 border-primary rounded-[30px] p-5 hidden xl:inline-block fixed mx-10 my-8 w-[65vw] md:w-[80vw] lg:w-[85vw] 3xl:w-[1100px]'>
                <p className='font-inter text-primary font-bold text-xl text-center'>
                  {isLoader ? (<CircularProgress open={isLoader} sx={{color: '#A31732'}}/>) : 'Aucune inscriptions'}
                </p>
              </div>
            )}
          </tbody>
        </CustomTable>
      </div>
    </div>
  );
}
